/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
function nextUntil(element, selector) {
    var siblings = [];
    var nextSibling = element.nextElementSibling;

    while (nextSibling) {
        if (nextSibling.matches(selector)) {
            break;
        }

        siblings.push(nextSibling);
        nextSibling = nextSibling.nextElementSibling;
    }

    return siblings;
}

window.addEventListener('DOMContentLoaded', function() {
  // Cart page
  if (document.body.classList.contains('template-cart')) {
    const zipCodes = [601,602,603,604,605,606,610,611,612,613,614,616,617,622,623,624,627,631,636,637,638,641,646,647,650,652,653,656,659,660,662,664,667,669,670,674,676,677,678,680,681,682,683,685,687,688,690,692,693,694,698,703,704,705,707,714,715,716,717,718,719,720,721,723,725,726,727,728,729,730,731,732,733,734,735,736,737,738,739,740,741,742,744,745,751,754,757,765,766,767,769,771,772,773,775,777,778,780,782,783,784,785,786,791,792,794,795,901,902,906,907,908,909,910,911,912,913,914,915,916,917,918,919,920,921,922,923,924,925,926,927,928,929,930,931,933,934,935,936,937,939,940,949,950,951,952,953,954,955,956,957,958,959,960,961,962,963,965,966,968,969,970,971,975,976,977,978,979,981,982,983,984,985,986,987,988,83226,83227,83229,83235,83253,83278,83414,83462,83463,83464,83465,83466,83467,83468,83469,96006,,96009,96015,96054,96068,96101,96104,96108,96110,96112,96115,96116,96119,96701,96703,96704,96705,96706,96707,96708,96709,96710,96712,96713,96714,96715,96716,96717,96718,96719,96720,96721,96722,96725,96726,96727,96728,96729,96730,96731,96732,96733,96734,96737,96738,96739,96740,96741,96742,96743,96744,96745,96746,96747,96748,96749,96750,96751,96752,96753,96754,96755,96756,96757,96759,96760,96761,96762,96763,96764,96765,96766,96767,96768,96769,96770,96771,96772,96773,96774,96776,96777,96778,96779,96780,96781,96782,96783,96784,96785,96786,96788,96789,96790,96791,96792,96793,96795,96796,96797,96801,96802,96803,96804,96805,96806,96807,96808,96809,96810,96811,96812,96813,96814,96815,96816,96817,96818,96819,96820,96821,96822,96823,96824,96825,96826,96828,96830,96836,96837,96838,96839,96840,96841,96843,96844,96846,96847,96848,96849,96850,96853,96854,96857,96858,96859,96860,96861,96863,97406,97407,97411,97414,97415,97420,97423,97441,97444,97449,97450,97458,97459,,97464,97465,97466,97467,,97473,97476,97491,97501,97502,97503,97504,97520,97522,97523,97524,97525,97526,97527,97528,97530,97531,97532,97533,97534,97535,97536,97537,97538,97539,97540,97541,97543,97544,97601,97602,97603,97604,97620,97621,97622,97623,97624,97625,97626,97627,97630,97632,97633,97634,97635,97636,97637,97638,97639,97640,97641,99801,99802,99803,99811,99812,99820,99821,99824,99825,99826,99827,99829,99830,99832,99835,99836,99840,99841,99850,99901,99903,99918,99919,99921,99922,99923,99925,99926,99927,99928,99950,78003,83424,99402,98826,85929]
   
    const validateZipCode = function(event, zipCodeEl) {
      const value = zipCodeEl.value
         
      const zipCode = Number(value)
  
      return (3 <= value.length <= 5 && zipCodes.includes(zipCode))
    }
  
    const updateError = function(show) {
      const errorEl = document.querySelector('.js-cart-zipcode-error')
      errorEl.classList.toggle('js-active', show)
  
      document.querySelector('.cart__block--subtotal').scrollIntoView(true)
    }
  
    const updateMessage = function(show) {
      const successEl = document.querySelector('.js-cart-zipcode-success')
      successEl.toggleAttribute('hidden', show)
      
      const warningEl = document.querySelector('.js-cart-zipcode-warning')
      warningEl.toggleAttribute('hidden', !show)
    }
  
    const cartZipCodeEl = document.getElementById('cart-zipcode')
  
    cartZipCodeEl.addEventListener('input', function(e) {
      const isInRange = validateZipCode(e, event.target)
  
      const successEl = document.querySelector('.js-cart-zipcode-success')
      if (event.target.value.length > 0) {
        successEl.toggleAttribute('hidden', isInRange)
      } else {
        successEl.setAttribute('hidden', true)
      }
      
      const warningEl = document.querySelector('.js-cart-zipcode-warning')
      warningEl.toggleAttribute('hidden', !isInRange)
      
      updateError(false)
    })

    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('js-cart-zipcode-validate') && cartZipCodeEl.value.length === 0) {
        updateError(true)
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    })
  }

  // Product page
  if (document.body.classList.contains('template-product')) {
    /** Unique tabs using H6 as an anchor **/
    const description = document.querySelector('.product-single__box__block--description')
    const accordionGroup = document.querySelector('.product-single__box__block--tab accordion-group')
  
    description.querySelectorAll('h6').forEach( (heading, index) => {
      const tabName = heading.innerHTML
  
      if (tabName !== '') {
        // Get contents
        const elementsUntil = nextUntil(heading, 'h6');
    
        const tabContent = elementsUntil.reduce((accumulator, currentValue) => accumulator + currentValue.innerHTML, '');
  
        elementsUntil.forEach(elem => elem.style.display = 'none')
  
        // Generate accordion
        const accordion = document.createElement('details')
        accordion.id = `acc-unique-${index}`
        accordion.innerHTML = `
            <summary>
                <h3 class="f-family--body u-large u-text-transform--none u-color-text">
                  ${tabName}
                </h3>
                <summary-icon>
                    <i class="icon icon--plus-t" aria-hidden="true"></i>
                </summary-icon>
            </summary>
            <details-content>
                <div class="product-single__accordion__item-wrap rte">
                    ${tabContent}
                </div>
            </details-content>
        `
        accordionGroup.append(accordion)
      }
      
      // Hide from description
      heading.style.display = 'none'
    })
  }

  $('.popup-modal').magnificPopup({
      type: 'inline',
      preloader: false,
      focus: '#username',
      modal: true,
      showCloseBtn:true
  });
  $(document).on('click', '.popup-modal-dismiss', function (e) {
      e.preventDefault();
      $.magnificPopup.close();
  });
});